import { WorkflowAdapter } from "@validereinc/domain";
import { useGetList, useGetOne } from "./adapterUtils";
import { Resources } from "@validereinc/domain";
/** TODO: All workflows should be on the `Resources.WORKFLOW` key */

export const useGetOneWorkflow = useGetOne(
  WorkflowAdapter.getOne,
  Resources.WORKFLOW
);

export const useListWorkflows = useGetList(
  WorkflowAdapter.getList,
  Resources.WORKFLOW
);
